/*
 * @Date: 2023-03-14 14:07:15
 * @LastEditors: simLarry
 * @LastEditTime: 2023-06-11 11:31:40
 * @FilePath: \F1-M1-QRP-CODE\components\download\index.js
 */
import React from "react";
import { ApiPort } from "../../actions/API";
import { fetchRequest } from "../../config/Fatch.config";
import QRCode from 'qrcode';
import { Modal } from "antd";
import { getAffFromCookie } from "../../actions/util";
class Register extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            nativeAppUrl : props.nativeAppUrl,
            qrpic:'',
            iosDownload: false,
            andDownload: false
        }


        
    }
   
    componentWillReceiveProps(nextProps , prevState){
        if(nextProps.nativeAppUrl !== prevState.nativeAppUrl){
            this.getQrcodeUrl(nextProps.nativeAppUrl);
        }
        return ;
    }
    // static getDerivedStateFromProps(nextProps , prevState){
    //     if(nextProps.nativeAppUrl !== prevState.nativeAppUrl){
    //         console.log(prevState);
    //         return {nativeAppUrl : nextProps.nativeAppUrl};
    //     }
    //     return null;
    // }



    checkURL(url){
        let aff  ;
        let startIndex = 0;
        if (url.indexOf('#') !== -1) {
            startIndex = url.indexOf('#');
        }
    
        if(url.indexOf('?',startIndex) === -1){

            aff = getAffFromCookie() && '?aff='+getAffFromCookie();
            
        }else{
            if(url.includes("?aff")){
                aff = '';
            }else{
                aff = getAffFromCookie() && '&aff='+getAffFromCookie();
            }
        }
        return aff;
    }

    async getQrcodeUrl(nativeAppUrl){
        let aff = this.checkURL(nativeAppUrl);
        if(typeof nativeAppUrl === 'string' && nativeAppUrl !== ''){
            let database = await QRCode.toDataURL(nativeAppUrl + aff);
            this.setState({
                qrpic : database
            })
        }
    }


    




    render(){
        let { qrpic } = this.state;
        let { nativeAppUrl } = this.props;
        
        return (
            <>
                <div className="register-box web-qrcode">
                    <div className="box-head">
                        <img className="icon icon2" src="/static/images/settings_1.png" />
                        <p>安装步骤</p>
                    </div>

                    <div className="qrcode-content">

                        
                        <img style={{width:'60%'}} src={qrpic} />
                        
                        
                        {/* IOS 点击下载 */}
                        <div className="Down">
                            <div className="btnDownload">
                                <img src="/static/images/IOS_0.png" />
                                <p onClick={()=> this.setState({iosDownload: true})}>IOS 点击下载</p>
                            </div>
                            {/* Android 点击下载 */}
                            <div className="btnDownload">
                                <img src="/static/images/Android_0.png" />
                                <p onClick={()=> this.setState({andDownload: true})}>Android 点击下载</p>
                            </div>
                        </div>
                        <div className="down-tips"> 
                            <p>建议使用苹果版本9(含)以上的装置</p>
                            <p>建议使用版本6(含)以上</p>
                        </div>



                        <ol className="installation">
                            <li>扫二维码或点击下载</li>
                            <li>(Android)下载完成后安装即可</li>
                            <li>(iOS)下载完成后，进入手机中 设置＞通用＞设备管理＞查询设备UDID，点击安装＞输入密码＞点击安装＞回下载页面点击安装。</li>
                            <li>打开App进行游戏</li>
                        </ol>
                    </div>

                    
                </div>


                {/*  Phone Ipad */}

                <div className="register-box mobile-qrcode">
                    <div className="box-head">
                        <img className="icon icon2" src="/static/images/settings_1.png" />
                        <p>安装步骤</p>
                    </div>

                    <div className="qrcode-content">

                        <ol className="installation">
                            <li>扫二维码或点击下载</li>
                            <li>(Android)下载完成后安装即可</li>
                            <li>(iOS)下载完成后，进入手机中 设置＞通用＞设备管理＞查询设备UDID，点击安装＞输入密码＞点击安装＞回下载页面点击安装。</li>
                            <li>打开App进行游戏</li>
                        </ol>

                        <div className="btn-download-pc" style={{margin:'10px auto'}} onClick={()=>{global.location.href = nativeAppUrl}}>下载APP</div>
                        <p style={{fontSize:'1em',color:'#aaa'}}>建议使用苹果版本9(含)以上的装置</p>
                    </div>

                    
                </div>
                {this.state.andDownload && 
                    <Modal
                        visible={this.state.andDownload}
                        title="安卓安装教程"
                    >
                        <div>
                            <p>1. 扫描二维码或点击下载客户端</p>
                            <p>2. 在右上角选择在浏览器打开</p>
                            <p>3. 点击下载</p>
                            <p>4. 下载完成之后选择安装</p>
                            <p>5. 安装成功</p>
                            <div className="downloadOk" onClick={()=> this.setState({andDownload: false})}>
                                联知道啦
                            </div>
                        </div>
                    </Modal>
                }
                {this.state.iosDownload && 
                    <Modal
                        visible={this.state.iosDownload}
                        title="苹果安装教程"
                    >
                        <div>
                            <p>1. 允许打开配置描述文件</p>
                            <p>2. 打开设置一通用一设备管理</p>
                            <p>3. 选择查询设备UUID并点击安装</p>
                            <p>4. 输入密码</p>
                            <p>5. 点击安装</p>
                            <p>6. 自动跳转至下载页面，点击下载，等待下载完成点击安装</p>
                            <p>7. 回到桌面完成安装！</p>
                            <div className="downloadOk" onClick={()=> this.setState({iosDownload: false})}>
                                联知道啦
                            </div>
                        </div>
                    </Modal>
                }

            </>
        )
    }
}


export default Register;